// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3CfBd","postfix":"Logo_postfix__1qLU6"};